import CookieConsentCategorySelection from './CookieConsentCategorySelection';

export default CookieConsentCategorySelection;
